import React from 'react';
import { MapPin, Star, Edit2, Camera, User } from 'lucide-react';

const WorkerHero = ({
  avatarRef,
  ProfileImage,
  preview,
  handleHeroAvatar,
  fullName,
  professionalTitle,
  rating,
  reviews,
  address,
  jobsDone,
  activeJobs,
  Earnings,
  openEdit
}) => {
  return (
    <>
      {/* Hero */}
      <div className="wp-hero">
        <div
          className="wp-hero__avatar"
          onClick={() => avatarRef.current.click()}
          style={{ cursor: "pointer" }}
        >
          {ProfileImage
            ? <img
              src={preview || ProfileImage}
              alt="av"
              style={{
                width: "100%",
                height: "100%",
                borderRadius: "50%",
                objectFit: "cover"
              }}
            />
            : <User size={38} />
          }
          <button
            className="wp-hero__cam"
            type="button"
            onClick={(e) => {
                e.stopPropagation();
                avatarRef.current.click();
            }}
          >
            <Camera size={14} />
          </button>
          <input ref={avatarRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={handleHeroAvatar} />
        </div>
        <h2 className="wp-hero__name">{fullName}</h2>
        <p className="wp-hero__title">{professionalTitle}</p>
        <div className="wp-hero__rating">
          <Star size={14} fill="#f59e0b" color="#f59e0b" />
          <span>{rating}</span>
          <span className="wp-hero__reviews"> ({reviews} Reviews)</span>
        </div>
        {/* <div className="wp-hero__location"><MapPin size={13} /> {address}</div> */}
      </div>

      {/* Stats */}
     <div className="wp-stats">

  {/* Active / Upcoming Jobs */}
  <div className="wp-stat">
    <strong>{jobsDone ?? 0}</strong>
    <span> Completed Jobs</span>
  </div>

  {/* Dummy Earnings */}
  <div className="wp-stat wp-stat--mid">
    <strong>{Earnings}</strong>
    <span>Earnings</span>
  </div>

  {/* Completed Jobs */}
  <div className="wp-stat wp-stat--green">
    <strong>{activeJobs ?? 0}</strong>
    <span>Active Jobs</span>
  </div>

</div>

      {/* Edit Profile Buttons */}
      <div className="wp-edit-wrap">
        {/* Mobile → opens modal */}
        <button
          className="wp-edit-btn"
          onClick={openEdit}
        >
          <Edit2 size={15} />
          Edit Profile
        </button>
        {/* Desktop → opens full page */}

      </div>
    </>
  );
};

export default WorkerHero;